import actions from "./actions";

const initialState = {
  listLoading: false,
  totalLoading: false,
  detail: {},
  total: [],
  alertTotal: [],
  list: [],
  meta: {},
  error: false,
};

export default function gaugeReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
